<template>
  <div class="p-4 color-gray-80">
    <div
      class=""
      v-html="mentions"
    />

    <div
      class=""
      v-html="renvois"
    />
  </div>
</template>

<script>
/**
 */
export default {
  name: 'MentionsVigeo',
  props: {
    mentions: {
      type: String,
      required: true
    },
    renvois: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.color-gray-80 {
    color: $gray !important;
}
</style>